// extracted by mini-css-extract-plugin
module.exports = {"copy-to-clipboard-button":"style_copy-to-clipboard-button__29IxT"};